const appBaseName = "/registration"

const esIgnoreRedirectRouteList = [
  "/error",
  "/",
  "/email-verification",
  //dev
  "/contacts",
  "/credentials",
  "/signup-bonus",
  "/thankyou",
  "/terms-and-conditions",
  "/personal-data-document",
  "/personal-data-address",
  "/recharge-limits",
  "/recap-ocr",
]

const callbackPages = ["/ocr-callback/seu"]

const defaultDate = new Date("01/01/2000")

const PDFUrls = () => {
  const isSsr = typeof window === "undefined"

  return {
    privacy: isSsr
      ? process.env.APP_PRIVACY_POLICY_URL
      : window.APP_PRIVACY_POLICY_URL,
    contract: isSsr ? process.env.APP_CONTRACT_URL : window.APP_CONTRACT_URL,
    termsAndConditions: isSsr
      ? process.env.APP_TERMS_OF_USE_URL
      : window.APP_TERMS_OF_USE_URL,
  }
}

const FaqUrl = () => {
  const isSsr = typeof window === "undefined"

  const APP_MAIN_SITE_HOMEPAGE = isSsr
    ? process.env.APP_MAIN_SITE_HOMEPAGE
    : window.APP_MAIN_SITE_HOMEPAGE

  return `${APP_MAIN_SITE_HOMEPAGE}/ayuda`
}

export {
  FaqUrl,
  PDFUrls,
  appBaseName,
  callbackPages,
  defaultDate,
  esIgnoreRedirectRouteList,
}
